import { core } from 'types';
import { toJSONArray } from '@tock/coretypes';
import ClowncarAppConstants from 'constants/ClowncarAppConstants';

interface State {
  businessFeatures: core.Feature[];
  businessFeaturesLoaded: boolean;
  businessesLoaded: boolean;
  features: core.Feature[];
  featuresLoaded: boolean;
  isInitialized: boolean;
}

const initialState: State = {
  businessFeatures: [],
  businessFeaturesLoaded: false,
  businessesLoaded: false,
  features: [],
  featuresLoaded: false,
  isInitialized: false,
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload } = action;
  switch (type) {
    case ClowncarAppConstants.FEATURE_BUSINESS_FETCH_STARTING:
      return {
        ...state,
        businessFeaturesLoaded: false,
      };
    case ClowncarAppConstants.FEATURE_BUSINESS_FETCH_DONE:
      return {
        ...state,
        businessFeatures: toJSONArray<core.Feature>(payload),
        businessFeaturesLoaded: true,
      };
    case ClowncarAppConstants.FEATURES_FETCH_STARTING: {
      return {
        ...state,
        featuresLoaded: false,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.FEATURES_FETCH_DONE: {
      return {
        ...state,
        features: toJSONArray<core.Feature>(payload),
        featuresLoaded: true,
        isInitialized: state.businessesLoaded,
      };
    }
    case ClowncarAppConstants.BUSINESSES_FETCH_STARTING: {
      return {
        ...state,
        businessesLoaded: false,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.BUSINESSES_FETCH_DONE: {
      return {
        ...state,
        businessesLoaded: true,
        isInitialized: state.featuresLoaded,
      };
    }
    default:
      return state;
  }
}
